module.exports = __webpack_public_path__ + "static/media/content.0b0fa076.svg";